import React from 'react'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { bankAccountsRouteProps } from 'src/navigation/routeProps'
import BankAccountsPage from 'src/page-components/Organization/BankAccountsPage/BankAccountsPage'

const BankAccountsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsBankAccounts,
  routeProps: bankAccountsRouteProps,
  component: <BankAccountsPage />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default BankAccountsAppRoute
